<div
  class="component-container"
  id="height-chart-container"
>
  <div *ngIf="printData?.userName" class="heading">
    <div class="title">
      {{ printData?.userName }}
    </div>
  </div>
  <div
    class="heading flex xs:flex-col sm:flex-row md:flex-row justify-between items-start"
  >
    <div class="title">
      <ng-container *ngIf="!printData">
        {{ !memberId ? 'My ' : '' }}BMI
      </ng-container>
      <ng-container *ngIf="printData">
        {{ !memberId ? 'My ' : '' }}BMI Progress
      </ng-container>
      <span class="additional-text">{{ additionalText }}</span><br>
      <span class="additional-text">{{ additionalText2 }}</span>
    </div>
    <div
      *ngIf="(userRole === roles.participant || isAdult) && !printData"
      class="chart-type-selector flex flex-row xs:flex-col xs:mt-[1rem] justify-between items-center"
    >
      <app-radio-input
        [parentFormGroup]="form"
        controlName="chartType"
        [options]="chartTypeOptions"
      />
    </div>
    <div
      class="controls flex flex-row xs:flex-col xs:mt-[1rem] justify-between items-center"
    >
      <div
        *ngIf="(userRole === roles.participant || isAdult) && !printData"
        class="bmi-goal-select flex flex-row items-center xs:space-x-[0.5rem] space-x-[1rem]"
      >

        <span class="required-mark">*</span><span class="label">Compared to :</span>
        <app-dropdown
          [loading]="isAdult ? adultBmiGoalFilter?.loading : bmiGoalFilter?.loading"
          [options]="isAdult ? adultBmiGoalFilter?.list : bmiGoalFilter?.list"
          [parentFormGroup]="form"
          class="w-[22rem]"
          controlName="bmiGoal"
          type="small"
        />
      </div>
    </div>
    <div
      class="controls flex flex-row xs:flex-col xs:mt-[1rem] justify-between items-center"
    >
      <div class="flex flex-row items-center">
        <mat-checkbox
          (change)="onRoleToggle(item)"
          *ngFor="let item of legendList"
          [checked]="item.checked"
          [disabled]="chartTableData?.loading"
          [style]="{'--checkbox-color': item.color}"
        >
          {{ item.label }}
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div
    class="chart-container flex-row flex w-full xs:h-[50rem] sm:h-[50rem] md:h-[50rem]"
  >
    <div
      *ngIf="defaultPercentileLoading || chartData?.loading"
      class="chart-loader w-full h-full flex justify-center items-center"
    >
      <mat-spinner
        [diameter]="60"
        strokeWidth="5"
      />
    </div>
    <line-chart
      *ngIf="!defaultPercentileLoading && chartData?.data"
      chartName="bmi-chart"
      [chartData]="chartData.data"
      [xAxisLabel]="'Date'"
      [yAxisLabel]="(userRole === roles.participant || isAdult) ?
                    form.controls.chartType.value === 'percent' ?
                      'Percent Over '+selectedBMIGoal?.value
                    : form.controls.chartType.value === 'lbs' ?
                        'Pounds Over '+selectedBMIGoal?.value+''
                      : 'BMI'
                    : 'BMI'"
      class="w-full"
    />
    <div
      *ngIf="!defaultPercentileLoading && !chartData?.loading && !chartData?.data"
      class="no-chart-data w-full h-full flex justify-center items-center"
    >
      No data to show on chart.
    </div>
  </div>
  <div
    *ngIf="form.controls.chartType.value === 'percent' && changeInPercentOver !== null && isCoachEntered === true"
    class="change-in-percent-box"
  >
    Change in Percent Over {{ selectedBMIGoal?.value }} since first measure = {{ changeInPercentOver }}
  </div>
  <div class="table-container w-full">
    <div class="w-full xs:overflow-x-auto sm:overflow-x-auto">
      <div
        (scrolled)="onScroll()"
        [fromRoot]="true"
        [immediateCheck]="true"
        [infiniteScrollDisabled]="!chartData?.data"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
        [scrollWindow]="false"
        class="table-wrapper table-container xs:w-[80rem] sm:w-[80rem] md:w-full {{printData?'':'xs:max-h-[85vh] sm:max-h-[85vh] md:max-h-[calc(90vh-6rem)] xl:max-h-[calc(95vh-6rem)] overflow-auto'}}"
        infiniteScroll
      >
        <table
          *ngIf="chartTableData?.data?.list?.length"
          [dataSource]="chartTableData?.data?.list"
          mat-table
        >
          <ng-container matColumnDef="addedBy">
            <th
              *matHeaderCellDef
              mat-header-cell
            > Captured by
            </th>
            <td
              *matCellDef="let element"
              class="w-[12rem]"
              mat-cell
            >

              <div
                class="role-color-circle-container flex flex-row items-center"
              >
                <div
                  [style]="{ 'background-color':
                    roleDecorators[element.isCoachEntered ? 1 : 2].color}"
                  class="role-color-circle w-[0.8rem] h-[0.8rem]"
                ></div>
                <span
                  [matTooltip]="element.addedBy.name"
                  matTooltipClass="metric-role-tooltip"
                >{{ roleDecorators[element.isCoachEntered ? 1 : 2].label }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="recordedOn">
            <th
              *matHeaderCellDef
              mat-header-cell
              class="sortable-header cursor-pointer"
              (click)="onSort('recordedOn')"
            > 
              Measurement Date
              <span class="sort-indicator">
                <ng-container *ngIf="sortColumn === 'recordedOn'">
                  <span *ngIf="sortOrder === 'asc'">↑</span>
                  <span *ngIf="sortOrder === 'desc'">↓</span>
                </ng-container>
              </span>
            </th>
            <td
              *matCellDef="let element"
              class="w-[16rem]"
              mat-cell
            > {{
                element.recordedOn |
                  date:'MMM dd, yyyy'
              }}
            </td>
          </ng-container>

<!--          <ng-container matColumnDef="sessions">-->
<!--            <th-->
<!--              mat-header-cell-->
<!--              class="w-[25%]"-->
<!--              *matHeaderCellDef-->
<!--            >-->
<!--              Session-->
<!--            </th>-->
<!--            <td-->
<!--              style="-->
<!--                min-width: 12rem;-->
<!--                max-width: 18rem;-->
<!--                overflow: visible;-->
<!--                white-space: nowrap;-->
<!--              "-->
<!--              class="sessions-cell w-[25%]"-->
<!--              mat-cell-->
<!--              *matCellDef="let element"-->
<!--            >-->
<!--              <ng-container *ngIf="element.sessions?.length; else noSessions">-->
<!--                <div-->
<!--                  *ngFor="let session of element.sessions"-->
<!--                  class="td-cell session flex flex-col gap-[1rem]"-->
<!--                >-->
<!--                  <div-->
<!--                    *ngIf="session['sessionNumber']"-->
<!--                    class="session flex flex-row justify-start items-center gap-x-[1rem]"-->
<!--                  >-->
<!--                    <span class="pill-container">-->
<!--                      S{{ session.sessionNumber | number: "2.0-0" }}-->
<!--                    </span>-->
<!--                    <span class="session-date">-->
<!--                      {{ session.date | date: "MMM dd" }}-->
<!--                    </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </ng-container>-->
<!--              <ng-template #noSessions>-->
<!--                <span>-</span>-->
<!--              </ng-template>-->
<!--            </td>-->
<!--          </ng-container>-->

          <ng-container matColumnDef="height">
            <th
              *matHeaderCellDef
              mat-header-cell
            >Height (feet, inches)
            </th>
            <td
              *matCellDef="let element"
              mat-cell
            >
              <ng-container *ngIf="!element.imputed&&element.height">
                {{ element.height | heightFormat }}
              </ng-container>
              <ng-container *ngIf="element.imputed||!element.height">
                -
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="weight">
            <th
              *matHeaderCellDef
              mat-header-cell
            >
              Weight (pounds)
            </th>
            <td
              *matCellDef="let element"
              mat-cell
            >
              {{ element.weight }}
            </td>
          </ng-container>

          <ng-container matColumnDef="bmi">
            <th
              *matHeaderCellDef
              mat-header-cell
            >
              BMI
            </th>
            <td
              *matCellDef="let element"
              mat-cell
            > {{ element.bmi }}
            </td>
          </ng-container>

          <ng-container matColumnDef="bmiperc" *ngIf="!isAdult">
            <th
              *matHeaderCellDef
              mat-header-cell
            >
              {{ selectedBMIGoal?.value }}
            </th>
            <td
              *matCellDef="let element"
              mat-cell
            > {{ element.bmiperc }}
            </td>
          </ng-container>

          <ng-container matColumnDef="lbsover">
            <th
              *matHeaderCellDef
              mat-header-cell
            >Pounds Over {{ selectedBMIGoal.key === 0 ? '__' : selectedBMIGoal?.value }}
            </th>
            <td
              *matCellDef="let element"
              mat-cell
            > {{ element.lbsover }}
            </td>
          </ng-container>

          <ng-container matColumnDef="percover">
            <th
              *matHeaderCellDef
              mat-header-cell
            >
              Percent Over {{ selectedBMIGoal?.value }}
            </th>
            <td
              *matCellDef="let element"
              mat-cell
            >
              {{ element.percover }}
            </td>
          </ng-container>

          <tr
            *matHeaderRowDef="columns; sticky: true"
            mat-header-row
          ></tr>
          <tr
            *matRowDef="let row; columns: columns"
            mat-row
          ></tr>
          <tr
            *matNoDataRow
            class="mat-row"
          >
            <td
              [colSpan]="columns.length"
              class="mat-cell"
            >
              No data found.
            </td>
          </tr>
        </table>

        <div
          *ngIf="defaultPercentileLoading || (chartData?.data&&chartTableData?.loading)"
          class="chart-table-loader w-full h-[10rem] flex justify-center items-center"
        >
          <mat-spinner
            [diameter]="60"
            strokeWidth="5"
          />
        </div>
      </div>
    </div>
  </div>
</div>
